<template>
  <div class="schedule-container">
    <h2 class="section-title">Schedule</h2>
    
    <div class="row">
      <div class="col-lg-8">
        <div class="calendar-container">
          <div class="calendar-header">
            <button class="btn btn-sm btn-outline-primary" @click="prevMonth">&lt;</button>
            <h3>{{ currentMonthName }} {{ currentYear }}</h3>
            <button class="btn btn-sm btn-outline-primary" @click="nextMonth">&gt;</button>
          </div>
          
          <table class="calendar-table">
            <thead>
              <tr>
                <th v-for="day in weekdays" :key="day">{{ day }}</th>
              </tr>
            </thead>
            <!-- 修改日历单元格部分，添加点击事件和弹出层 -->
            <tbody>
              <tr v-for="(week, weekIndex) in calendarDays" :key="'week-'+weekIndex">
                <td 
                  v-for="(day, dayIndex) in week" 
                  :key="'day-'+dayIndex"
                  :class="{ 
                    'current-month': day.currentMonth, 
                    'has-events': hasEvents(day.date),
                    'today': isToday(day.date),
                    'selected': isSelectedDate(day.date)
                  }"
                  @click="selectDate(day.date, $event)"
                  ref="calendarCells"
                >
                  <div class="day-number">{{ day.day }}</div>
                  <div class="day-events-list" v-if="hasEvents(day.date)">
                    <div v-for="(event, eventIndex) in getEventsForDay(day.date, 2)" :key="'event-'+eventIndex" class="day-event-item">
                      <span class="event-time-small">{{ event.time }}</span>
                      <span class="event-title-small">{{ event.title }}</span>
                    </div>
                    <div v-if="countEventsForDay(day.date) > 2" class="more-events">
                      更多 +{{ countEventsForDay(day.date) - 2 }}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>

            
            <!-- 将弹窗移到table外部 -->
            <div class="event-popup" v-if="selectedDate && showEventPopup" :style="popupStyle" :key="popupKey">
              <div class="event-popup-header">
                <h4>{{ formatSelectedDate }}</h4>
                <button class="close-btn" @click="closeEventPopup">&times;</button>
              </div>
              <div class="event-popup-content">
                <div class="events-list" v-if="eventsForSelectedDate.length > 0">
                  <div class="event-item" v-for="(event, index) in eventsForSelectedDate" :key="'event-'+index">
                    <div class="event-time">{{ event.time }}</div>
                    <div class="event-content">
                      <h5>{{ event.title }}</h5>
                      <p>{{ event.description }}</p>
                    </div>
                  </div>
                </div>
                <div class="no-events" v-else>
                  <p>No events scheduled for this day.</p>
                </div>
              </div>
            </div>
            
            <!-- 移除原来的下方事件详情展示 -->
            <!-- <div class="selected-date-events" v-if="selectedDate">
              <h4>{{ formatSelectedDate }}</h4>
              <div class="events-list" v-if="eventsForSelectedDate.length > 0">
                <div class="event-item" v-for="(event, index) in eventsForSelectedDate" :key="'event-'+index">
                  <div class="event-time">{{ event.time }}</div>
                  <div class="event-content">
                    <h5>{{ event.title }}</h5>
                    <p>{{ event.description }}</p>
                  </div>
                </div>
              </div>
              <div class="no-events" v-else>
                <p>No events scheduled for this day.</p>
              </div>
            </div> -->
          </table>
        </div>
      </div>
      
      <div class="col-lg-4">
        <div class="events-form">
          <h3>Big Events</h3>
          <!-- 大事件列表 -->
          <div class="big-events-list">
            <!-- 高考事件 -->
            <div class="big-event-item" @click="toggleEventDetails('gaokao')">
              <div class="event-header">
                <span class="event-title">2025年普通高等学校招生全国统一考试</span>
                <i class="fas fa-chevron-down" :class="{ 'rotated': expandedEvents.gaokao }"></i>
              </div>
              <div class="event-details" v-show="expandedEvents.gaokao">
                <div class="event-info">
                  <p>报名时间：2024年11月1日-11月15日</p>
                  <p>考试时间：2025年6月7日-6月9日</p>
                  <p>成绩公布：2025年6月24日</p>
                </div>
              </div>
            </div>
            <!-- 考研事件 -->
            <div class="big-event-item" @click="toggleEventDetails('kaoyan')">
              <div class="event-header">
                <span class="event-title">2025年全国硕士研究生统一招生考试</span>
                <i class="fas fa-chevron-down" :class="{ 'rotated': expandedEvents.kaoyan }"></i>
              </div>
              <div class="event-details" v-show="expandedEvents.kaoyan">
                <div class="event-info">
                  <p>预报名时间：2025年10月10日</p>
                  <p>正式报名：2025年10月20日</p>
                  <p>考试时间：2025年12月20日</p>
                </div>
              </div>
            </div>

            <!-- 四六级考试 -->
            <div class="big-event-item" @click="toggleEventDetails('cet')">
              <div class="event-header">
                <span class="event-title">2025年全国大学英语四、六级考试</span>
                <i class="fas fa-chevron-down" :class="{ 'rotated': expandedEvents.cet }"></i>
              </div>
              <div class="event-details" v-show="expandedEvents.cet">
                <div class="event-info">
                  <p>报名：2025年3月1日-3月15日</p>
                  <p>考试：2025年6月15日</p>
                  <p>查分：2025年8月下旬</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Schedule',
  data() {
    return {
      currentDate: new Date(),
      selectedDate: null,
      weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      events: [],
      expandedEvents: {
        gaokao: false,
        kaoyan: false,
        cet: false
      },
      reservation: {
        scheduleType: '',
        content: '',
        phoneNumber: '',
        email: ''  
      },
      showEventPopup: false,
      popupStyle: {
        top: '0px',
        left: '0px'
      },
      selectedCellIndex: null,
      popupKey: 0, // 添加一个key值用于强制重新渲染弹窗
      // 添加弹窗相关状态
      showModal: false,
      modalStatus: 'success',
      modalTitle: '',
      modalMessage: ''
    }
  },
  computed: {
    currentYear() {
      return this.currentDate.getFullYear();
    },
    currentMonth() {
      return this.currentDate.getMonth();
    },
    currentMonthName() {
      return new Date(this.currentYear, this.currentMonth, 1).toLocaleString('default', { month: 'long' });
    },
    calendarDays() {
      const year = this.currentYear;
      const month = this.currentMonth;
      
      // First day of the month
      const firstDay = new Date(year, month, 1);
      // Last day of the month
      const lastDay = new Date(year, month + 1, 0);
      
      const daysInMonth = lastDay.getDate();
      const firstDayOfWeek = firstDay.getDay();
      
      // Previous month's days
      const prevMonthLastDay = new Date(year, month, 0).getDate();
      
      const days = [];
      let week = [];
      
      // Add previous month's days
      for (let i = 0; i < firstDayOfWeek; i++) {
        const day = prevMonthLastDay - firstDayOfWeek + i + 1;
        week.push({
          day,
          date: new Date(year, month - 1, day),
          currentMonth: false
        });
      }
      
      // Add current month's days
      for (let i = 1; i <= daysInMonth; i++) {
        week.push({
          day: i,
          date: new Date(year, month, i),
          currentMonth: true
        });
        
        if (week.length === 7) {
          days.push(week);
          week = [];
        }
      }
      
      // Add next month's days
      if (week.length > 0) {
        const daysToAdd = 7 - week.length;
        for (let i = 1; i <= daysToAdd; i++) {
          week.push({
            day: i,
            date: new Date(year, month + 1, i),
            currentMonth: false
          });
        }
        days.push(week);
      }
      
      return days;
    },
    eventsForSelectedDate() {
      if (!this.selectedDate) return [];
      
      return this.events.filter(event => {
        const eventDate = new Date(event.date);
        return (
          eventDate.getDate() === this.selectedDate.getDate() &&
          eventDate.getMonth() === this.selectedDate.getMonth() &&
          eventDate.getFullYear() === this.selectedDate.getFullYear()
        );
      });
    },
    formatSelectedDate() {
      if (!this.selectedDate) return '';
      
      return this.selectedDate.toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
  },
  mounted() {
    this.fetchEvents();
  },
  methods: {
    prevMonth() {
      this.currentDate = new Date(this.currentYear, this.currentMonth - 1, 1);
    },
    nextMonth() {
      this.currentDate = new Date(this.currentYear, this.currentMonth + 1, 1);
    },
    selectDate(date, dayIndex) {
      this.selectedDate = date;
      
      // 计算弹窗位置
      const cell = event.currentTarget;
      const cellRect = cell.getBoundingClientRect();
      const containerRect = this.$el.querySelector('.calendar-container').getBoundingClientRect();
      
      // 计算相对于日历容器的位置
      const relativeTop = cellRect.top - containerRect.top + cellRect.height / 2;
      const relativeLeft = cellRect.right - containerRect.left;
      
      // 设置弹窗样式
      this.popupStyle = {
        top: `${relativeTop}px`,
        left: `${relativeLeft + 10}px`,
        transform: 'translateY(-50%)'
      };
      
      // 检查是否靠近右边界，如果是则改为左侧显示
      const calendarWidth = containerRect.width;
      if (relativeLeft + 310 > calendarWidth) { // 310 = 弹窗宽度 + 边距
        this.popupStyle.left = `${cellRect.left - containerRect.left - 10}px`;
        this.popupStyle.right = 'auto';
        this.popupStyle.transform = 'translate(-100%, -50%)';
      }
      // 增加key值，强制重新渲染弹窗
      this.popupKey++;
      this.showEventPopup = true;
    },
    
    closeEventPopup() {
      this.showEventPopup = false;
    },
    
    isSelectedDate(date) {
      if (!this.selectedDate || !date) return false;
      
      return (
        date.getDate() === this.selectedDate.getDate() &&
        date.getMonth() === this.selectedDate.getMonth() &&
        date.getFullYear() === this.selectedDate.getFullYear()
      );
    },
    hasEvents(date) {
      if (!date) return false;
      
      // 添加调试信息
      // console.log('检查日期是否有事件:', date);
      
      return this.events.some(event => {
        // 确保event.date是Date对象
        const eventDate = event.date instanceof Date ? event.date : new Date(event.date);
        
        const isSameDay = 
          eventDate.getDate() === date.getDate() &&
          eventDate.getMonth() === date.getMonth() &&
          eventDate.getFullYear() === date.getFullYear();
          
        if (isSameDay) {
          // console.log('找到事件:', event);
        }
        
        return isSameDay;
      });
    },
    isToday(date) {
      if (!date) return false;
      
      const today = new Date();
      return (
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
      );
    },

    // 获取指定日期的事件，限制显示数量
    getEventsForDay(date, limit) {
      if (!date) return [];
      
      const dayEvents = this.events.filter(event => {
        const eventDate = event.date instanceof Date ? event.date : new Date(event.date);
        return (
          eventDate.getDate() === date.getDate() &&
          eventDate.getMonth() === date.getMonth() &&
          eventDate.getFullYear() === date.getFullYear()
        );
      });
      
      // 按时间排序
      dayEvents.sort((a, b) => {
        const timeA = a.date instanceof Date ? a.date : new Date(a.date);
        const timeB = b.date instanceof Date ? b.date : new Date(b.date);
        return timeA - timeB;
      });
      
      return dayEvents.slice(0, limit);
    },
    
    // 计算指定日期的事件总数
    countEventsForDay(date) {
      if (!date) return 0;
      
      return this.events.filter(event => {
        const eventDate = event.date instanceof Date ? event.date : new Date(event.date);
        return (
          eventDate.getDate() === date.getDate() &&
          eventDate.getMonth() === date.getMonth() &&
          eventDate.getFullYear() === date.getFullYear()
        );
      }).length;
    },
    async fetchEvents() {
      try {
        const response = await axios.get('/schedule');
       // 处理日期格式，将字符串转换为Date对象
       this.events = response.data.map(event => {
          return {
            id: event.id,
            title: event.title,
            description: event.description,
            date: new Date(event.dateTime), // 将字符串转换为Date对象
            time: new Date(event.dateTime).toLocaleTimeString('zh-CN', {
              hour: '2-digit',
              minute: '2-digit'
            }),
            eventType: event.eventType
          };
        });
        
        // console.log('处理后的事件数据:', this.events);
      } catch (error) {
        console.error('Error fetching events:', error);
        // Mock data for development
        this.events = [
          {
            id: 1,
            title: 'IELTS Vocabulary Class',
            description: 'Focus on academic vocabulary for IELTS writing',
            date: new Date(2023, 10, 15),
            time: '10:00 AM'
          },
          {
            id: 2,
            title: 'Speaking Practice',
            description: 'One-on-one speaking practice session',
            date: new Date(2023, 10, 18),
            time: '2:00 PM'
          },
          {
            id: 3,
            title: 'Legal English Workshop',
            description: 'Specialized terminology for legal professionals',
            date: new Date(2023, 10, 22),
            time: '3:30 PM'
          }
        ];
      }
    },
    
    toggleEventDetails(eventType) {
      // Toggle the expanded state for the specified event type
      this.expandedEvents[eventType] = !this.expandedEvents[eventType];
    },
  }
}
</script>

<style scoped>
.schedule-container {
  padding: 2rem 5%;
  background-color: #f8f9fa;
}

.section-title {
  text-align: center;
  margin-bottom: 3rem;
  font-size: 2.5rem;
  color: #2c3e50;
}

/* 调整日历容器为相对定位，作为弹出层的参考 */
.calendar-container {
  position: relative;
  background: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  margin-bottom: 2rem;
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.calendar-header h3 {
  margin: 0;
  font-size: 1.5rem;
  color: #2c3e50;
}

.calendar-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed; /* 添加固定表格布局 */
}

.calendar-table th {
  padding: 0.5rem;
  text-align: center;
  font-weight: 500;
  color: #7f8c8d;
  width: 14.28%; /* 每列宽度固定为总宽度的1/7 */
}

.calendar-table td {
  padding: 0.5rem;
  text-align: left;
  height: 100px; /* 增加单元格高度 */
  border: 1px solid #e0e0e0;
  cursor: pointer;
  position: relative;
  vertical-align: top;
  width: 14.28%; /* 每列宽度固定为总宽度的1/7 */
  box-sizing: border-box; /* 确保padding不会影响总宽度 */
}

.day-number {
  font-size: 1rem;
  font-weight: 500;
  margin-bottom: 5px;
}

.day-events-list {
  display: flex;
  flex-direction: column;
  font-size: 0.75rem;
  margin-top: 2px;
  overflow: hidden;
}

.day-event-item {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 2px;
  padding: 1px 3px;
  border-radius: 2px;
  background-color: rgba(52, 152, 219, 0.1);
  border-left: 2px solid #3498db;
}

.event-time-small {
  font-weight: 500;
  color: #3498db;
  margin-right: 4px;
  font-size: 0.7rem;
}

.event-title-small {
  color: #2c3e50;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.more-events {
  font-size: 0.7rem;
  color: #7f8c8d;
  text-align: center;
  background-color: #f5f5f5;
  border-radius: 2px;
  padding: 1px 0;
  margin-top: 2px;
}

.calendar-table td:hover {
  background-color: #f5f5f5;
}

td.current-month .day-number {
  color: #2c3e50;
}

td:not(.current-month) .day-number {
  color: #bdc3c7;
}

td.today {
  background-color: #e8f4fd;
}

td.today .day-number {
  color: #3498db;
  font-weight: bold;
}

td.has-events {
  position: relative;
}

.event-indicator {
  width: 6px;
  height: 6px;
  background-color: #3498db;
  border-radius: 50%;
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translateX(-50%);
}

.selected-date-events {
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #e0e0e0;
}

.selected-date-events h4 {
  margin-bottom: 1rem;
  color: #2c3e50;
}

.events-list {
  max-height: 300px;
  overflow-y: auto;
}

.event-item {
  display: flex;
  margin-bottom: 1rem;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 5px;
  border-left: 4px solid #3498db;
}

.event-time {
  flex: 0 0 80px;
  font-weight: 500;
  color: #3498db;
}

.event-content {
  flex: 1;
}

.event-content h5 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  color: #2c3e50;
}

.event-content p {
  margin: 0;
  color: #7f8c8d;
}

.no-events p {
  color: #7f8c8d;
  font-style: italic;
}

.big-events-list {
  display: flex;
  flex-direction: column;
  gap: 1.2rem; /* 增加行间距 */
  height: calc(100% - 5rem); /* 减去标题和padding的高度 */
  overflow-y: auto; /* 内容过多时可滚动 */
}

.big-event-item {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #e0e0e0;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 0.5rem;
}

.big-event-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.event-header {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
  border-bottom: 1px solid #eee;
}

.event-title {
  font-weight: 500;
  color: #2c3e50;
  flex: 1;
  margin-right: 1rem;
}

.event-details {
  background: #fff;
  border-top: 1px solid #eee;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s ease-in-out, opacity 0.3s ease-in-out, padding 0.3s ease-in-out;
  opacity: 0;
  padding: 0;
}

/* 当元素显示时应用这些样式 */
.event-details:not([style*="display: none"]) {
  max-height: 200px;
  opacity: 1;
  padding: 1rem;
}

.event-info {
  background: white;
}

.event-info p {
  margin: 0.5rem 0;
  color: #666;
  font-size: 0.9rem;
}

.fa-chevron-down {
  transition: transform 0.3s ease;
}

.fa-chevron-down.rotated {
  transform: rotate(180deg);
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #2c3e50;
}

.form-control {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  transition: border-color 0.3s ease;
}

.form-control:focus {
  border-color: #3498db;
  outline: none;
}

.btn-primary {
  background-color: #3498db;
  border-color: #3498db;
}

.btn-primary:hover {
  background-color: #2980b9;
  border-color: #2980b9;
}

@media (max-width: 992px) {
  .row {
    flex-direction: column;
  }
  
  .col-lg-8, .col-lg-4 {
    width: 100%;
  }
  
  .reservation-form {
    margin-top: 2rem;
  }
}

/* 添加选中日期的样式 */
td.selected {
  background-color: #d4ebff;
  box-shadow: inset 0 0 0 2px #3498db;
}

/* 弹出事件详情层样式 */
.event-popup {
  position: absolute;
  width: 300px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  z-index: 100;
  top: 50%;
  transform: translateY(-50%);
  max-height: 400px;
  display: flex;
  flex-direction: column;
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-50%) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(-50%) scale(1);
  }
}

.popup-right {
  left: calc(100% + 10px);
  animation: slideInRight 0.3s ease forwards;
}

.popup-left {
  right: calc(100% + 10px);
  animation: slideInLeft 0.3s ease forwards;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateY(-50%) translateX(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(-50%) translateX(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateY(-50%) translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateY(-50%) translateX(0);
  }
}

.event-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  border-bottom: 1px solid #e0e0e0;
}

.event-popup-header h4 {
  margin: 0;
  font-size: 1.1rem;
  color: #2c3e50;
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #7f8c8d;
  cursor: pointer;
  padding: 0;
  line-height: 1;
}

.event-popup-content {
  padding: 15px;
  overflow-y: auto;
  flex-grow: 1;
}

/* 自定义弹窗样式 */
.custom-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}

.custom-modal-content {
  background-color: white;
  border-radius: 10px;
  padding: 30px;
  text-align: center;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  animation: scaleIn 0.3s ease;
}

.modal-icon {
  font-size: 60px;
  margin-bottom: 20px;
}

.success-icon {
  color: #2ecc71;
}

.error-icon {
  color: #e74c3c;
}

.custom-modal-content h4 {
  color: #2c3e50;
  margin-bottom: 15px;
  font-size: 1.5rem;
}

.custom-modal-content p {
  color: #7f8c8d;
  margin-bottom: 25px;
}

.custom-modal-content .btn {
  min-width: 120px;
}

@keyframes scaleIn {
  from {
    transform: scale(0.8);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* 大事件模块样式 */
.events-form {
  background: white;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  height: calc(100% - 2rem); /* 减去margin-bottom的高度 */
  margin-bottom: 2rem; /* 与日历容器保持一致的底部间距 */
}

.events-form h3 {
  text-align: center;
  margin-bottom: 2rem;
  color: #2c3e50;
  font-size: 1.8rem;
}

.countdown-module {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  border: 1px solid #eaeaea;
}

.countdown-title {
  font-size: 1.2rem;
  color: #2c3e50;
  margin-bottom: 1rem;
  text-align: center;
  font-weight: bold;
}

.countdown-time {
  text-align: center;
  font-size: 1.5rem;
  color: #3498db;
  font-weight: bold;
}

/* 考研事件轮播样式 */
.kaoyan-events {
  margin-top: 1rem;
  padding: 1rem 0;
  border-top: 1px solid #eaeaea;
}

.marquee {
  height: 80px;
  overflow: hidden;
}

.kaoyan-events .event-item {
  padding: 0.5rem;
  color: #666;
  text-align: center;
}

.event-list .event-item {
  display: flex;
  justify-content: space-between;
  padding: 0.8rem;
  border-bottom: 1px solid #eaeaea;
}

.event-list .event-item:last-child {
  border-bottom: none;
}

.event-date {
  color: #3498db;
  font-weight: 500;
}

.event-name {
  color: #2c3e50;
}

/* 响应式调整 */
@media (max-width: 992px) {
  .events-form {
    margin-top: 2rem;
  }
}
</style>
